// extracted by mini-css-extract-plugin
export default {"panelContainer":"OrderSMSMessagesContent_panelContainer__WDzZm"};